// @flow
export const filterId: 'group' = 'group';
